"use client";
import { motion, AnimatePresence } from "framer-motion";

export default function ConfirmModal({
    isOpen,
    onClose,
    onConfirm,
    title,
    description,
    confirmText = "تأیید",
    cancelText = "انصراف",
    loading = false,
}) {
    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50 backdrop-blur-sm"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    <motion.div
                        className="bg-black/80 rounded-2xl w-[90%] max-w-md p-6 shadow-lg border border-white/20 relative"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1}}
                        exit={{ opacity: 0, scale: 0.9 }}
                        transition={{ type: "spring", stiffness: 100, damping: 20 }}
                    >
                        <h3 className="text-lg font-semibold mb-1 text-foreground">
                            {title}
                        </h3>

                        <p className="text-sm text-white/60 mb-6 leading-relaxed">
                            {description}
                        </p>

                        <div className="flex justify-end gap-3">
                            <button
                                onClick={!loading ? onClose : undefined}
                                disabled={loading}
                                className={`px-4 py-2 rounded-lg text-sm font-medium border border-white/20 text-foreground transition ${loading && "opacity-50 cursor-not-allowed"
                                    }`}
                            >
                                {cancelText}
                            </button>

                            <button
                                onClick={!loading ? onConfirm : undefined}
                                disabled={loading}
                                className={`px-4 py-2 rounded-lg text-sm font-medium bg-red-500 hover:bg-red-600 text-foreground flex items-center gap-2 transition ${loading && "opacity-70 cursor-not-allowed"
                                    }`}
                            >
                                {loading && (
                                    <motion.span
                                        className="w-4 h-4 border-2 border-white border-t-transparent rounded-full"
                                        animate={{ rotate: 360 }}
                                        transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
                                    />
                                )}
                                {confirmText}
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}